var exports = {
  "HeroSequence": "HeroSequence__ewvN7g",
  "HeroSequence__content": "HeroSequence__content___kTisr",
  "HeroSequence__video": "HeroSequence__video__zxC1BE",
};

__webpack_require__.r(module.exports = exports);
